import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Chip,
  Alert,
  Grid2,
} from "@mui/material";
import FormatTime from "../../AdsPage/FormatTime";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
  myAdsListButtons,
} from "../../../Styles/Styles";

export default function MyAdsList({
  handleSoldClick,
  handleDeleteClick,
  handleEdit,
  handleViewOffers,
  handleViewAd,
  ads,
  error,
  loading,
}) {
  return (
    <Box sx={{ mt: 3 }}>
      {error && <Alert severity="error">{error}</Alert>}
      {ads.length > 0 && !loading && (
        <Grid2 container spacing={2}>
          {ads.map((ad) => (
            <Grid2 item size={{ xs: 12 }} key={ad._id}>
              <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  ...cardOutline,
                  ...cardHover,
                }}
              >
                {/* Left side image */}
                {ad.images?.[0]?.thumbnail ? (
                  <CardMedia
                    component="img"
                    image={ad.images[0]?.thumbnail} // Assuming the first image is the main one
                    alt={ad.title}
                    onClick={() => handleViewAd(ad.uniqueId)}
                    sx={{
                      width: 100, // Set a fixed width for the image
                      cursor: "pointer",
                      borderRadius: 1,
                      objectFit: "cover",
                      mr: 2, // Add right margin to space from content
                    }}
                  />
                ) : (
                  <Box
                    onClick={() => handleViewAd(ad.uniqueId)}
                    sx={{
                      width: 100,
                      height: 100,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "grey.200",
                      borderRadius: 1,
                      cursor: "pointer",
                      mr: 2,
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                      color: "text.secondary",
                    }}
                  >
                    {ad.title[0]}
                  </Box>
                )}

                {/* Right side content */}
                <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <CardContent sx={{ p: 0 }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ ...fonts }}
                    >
                      <FormatTime createdAt={ad.createdAt} />
                    </Typography>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{
                        ...headingFonts,
                        cursor: "pointer",
                        display: "inline",
                        "&:hover": {
                          color: "var(--primary-color)",
                        },
                      }}
                      onClick={() => handleViewAd(ad.uniqueId)}
                    >
                      {ad.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ ...fonts }}
                    >
                      <strong>Price:</strong> ${ad.price.toLocaleString()}
                    </Typography>
                    {ad.isSold && (
                      <Chip
                        label={
                          <Typography variant="body2" sx={{ ...fonts }}>
                            Sold
                          </Typography>
                        }
                        color="success"
                        sx={{ mt: 1 }}
                      />
                    )}
                  </CardContent>

                  {/* Action Buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                    {ad.receiveOffers && (
                      <Button
                        size="small"
                        sx={{ ...myAdsListButtons }}
                        onClick={() => handleViewOffers(ad.uniqueId)}
                      >
                        View Offers
                      </Button>
                    )}
                    <Button
                      size="small"
                      sx={{ ...myAdsListButtons }}
                      onClick={() => handleEdit(ad.uniqueId)}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      sx={{
                        textTransform: "none",
                        color: "red",
                        fontFamily: "ClashGrotesk-Medium",
                        letterSpacing: 1,
                        textAlign: "left",
                        border: "1px solid red",
                        "&:hover": { border: "1px solid red" },
                        "&:focus, &:active": { outline: "none" },
                      }}
                      onClick={() => handleDeleteClick(ad._id)}
                    >
                      Delete
                    </Button>
                    <Button
                      size="small"
                      sx={{ ...myAdsListButtons }}
                      color={ad.isSold ? "secondary" : "warning"}
                      onClick={() => handleSoldClick(ad.uniqueId, ad.isSold)}
                    >
                      {ad.isSold ? "Mark as Not Sold" : "Mark as Sold"}
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      )}
    </Box>
  );
}
